// DRAFT — REVIEW ARTIFACT — NOT DEPLOYED
//
// Badges an audience sensitivity tier. Accepts either the fixture's OLD 2-value scheme
// (proprietary / client_private) or the NEW 3-value domain and always displays the new
// reporting_sensitivity_tier vocabulary (ic_internal / adviser_restricted / retail_public),
// so the shell reads congruently with 0002's migrated column.

import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { ShieldAlert, ShieldCheck, Globe } from "lucide-react";
import type { LegacyTier, ReportingTier } from "@/types/ir";
import { normaliseTier, tierLabel, tierTone, toneDot } from "./labels";

export function SensitivityTierBadge({
  tier,
  className,
}: {
  tier: LegacyTier | ReportingTier | string | undefined;
  className?: string;
}) {
  const t: ReportingTier = normaliseTier(tier);
  const Icon = t === "retail_public" ? Globe : t === "adviser_restricted" ? ShieldCheck : ShieldAlert;
  return (
    <Badge variant="outline" className={cn("gap-1.5 font-body", className)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", toneDot(tierTone(t)))} aria-hidden />
      <Icon className="h-3 w-3" aria-hidden />
      {tierLabel(t)}
    </Badge>
  );
}
